import React from "react";
import {t} from "../../../../dev/helpers/translator";

export default function stackerBalanceTemplate () {
    return <div className="ticket-results-view-p">
        <h3>{t("How would you like to see the stacker balance?")}</h3>
        <div className="buttons-view-w-t">
            <ul>
                <li>
                    <div className="separator-box-buttons-m">
                        <button className="button-view-normal-m" onClick={this.printStackerBalance()}>
                            {t("Print")}
                        </button>
                    </div>
                </li>
                <li>
                    <div className="separator-box-buttons-m">
                        <button className="button-view-normal-m trans-m" onClick={this.stackerBalanceShow()}>
                            {t("Show")}
                        </button>
                    </div>
                </li>
            </ul>
        </div>
    </div>;
};